module.exports = {"pt-BR":{"admin":{"bills":{"paymentType":{"label":"Forma de pagamento","flag":{"pix":"PIX","bankSlip":"Boleto bancário"}}}}}}